import './WhatAreYouLookingFor.css';
import stopEventPropagation from '../ui_core/stopEventPropagation';
import PropertyBindingFactory from '../mvvm/PropertyBindingFactory';
import eventEnable from '../core/eventEnable';
import WhatAreYouLookingForToggleButton from './WhatAreYouLookingForToggleButton';
export default class WhatAreYouLookingForNBeds{
	constructor({siteJson, whatAreYouLookingForViewModel}){
		eventEnable(this);
		this._whatAreYouLookingForViewModel = whatAreYouLookingForViewModel;
		this._element = document.createElement('div');
		this._element.classList.add('n-beds');
		this._createSetNBedsButton= this._createSetNBedsButton.bind(this);
		this._get_setNBeds= this._get_setNBeds.bind(this);
		this._nBedroomsSelectedValueChanged = this._nBedroomsSelectedValueChanged.bind(this);
		this._nBedroomAvailableWithOtherOptionsChanged = this._nBedroomAvailableWithOtherOptionsChanged.bind(this);
		this._mapValueToToggleButton = new Map();
		this._toggleButtons=[];
		whatAreYouLookingForViewModel.nBedroomsValues.forEach(nBedsValue=>this._createSetNBedsButton(nBedsValue));
		this._propertyBindingNBedrooms = PropertyBindingFactory.standard(this, whatAreYouLookingForViewModel,
		'nBedrooms', this._nBedroomsSelectedValueChanged);
		this._propertyBindingNBedroomAvailableWithOtherOptions = PropertyBindingFactory.standard(this,
		whatAreYouLookingForViewModel,
		'nBedroomsAvailableWithOtherOptions', this._nBedroomAvailableWithOtherOptionsChanged);
	}
	_nBedroomsSelectedValueChanged(value){
		if(this._currentlySelectedButton){
			this._currentlySelectedButton.unselect();
			this._currentlySelectedButton=null;
		}
		const toggleButton = this._mapValueToToggleButton.get(value);
		if(!toggleButton)return;
		toggleButton.select();
		this._currentlySelectedButton=toggleButton;
	}
	_nBedroomAvailableWithOtherOptionsChanged(value){
		this._toggleButtons.forEach(toggleButton=>{
			const nBedrooms = toggleButton.value;
			toggleButton.setAvailableOption(value?.indexOf(nBedrooms)>=0?true:false);
		});
	}
	_createSetNBedsButton(nBedrooms){
		const toggleButton = new WhatAreYouLookingForToggleButton({
			callbackClicked:this._get_setNBeds(nBedrooms),
			text:String(nBedrooms),
			value:nBedrooms
		});
		this._mapValueToToggleButton.set(nBedrooms, toggleButton);
		this._element.appendChild(toggleButton.element);
		this._toggleButtons.push(toggleButton);
	}
	_get_setNBeds(nBedrooms){
		return (toggleButton)=>{
			if(toggleButton.selected){
				toggleButton.unselect();
				this._whatAreYouLookingForViewModel.nBedrooms=null;
				return;
			}
			this._whatAreYouLookingForViewModel.nBedrooms = nBedrooms;
			this.dispatchEvent({type:'chose'});
		};
	}
	get element(){
		return this._element;
	}
}